// caretOf — the block an editor event happened in, and the text selected
// there, read off the event's own target (principle 22: the assistant knows
// where the Author is). The block is the nearest `[data-element-id]` around
// the target (MaterialDocument.tsx puts one on every block); the selection
// is the text input's own selected range. Nothing else is read: no window,
// no document. Undefined: the event was outside any block.

export type { CaretAt };
export { caretOf };

type CaretAt = { readonly blockId: string; readonly selection?: string };

const caretOf = (target: EventTarget | null): CaretAt | undefined => {
    if (!(target instanceof HTMLElement)) return undefined;
    const blockId =
        target.closest<HTMLElement>("[data-element-id]")?.dataset.elementId;
    if (blockId === undefined || blockId === "") return undefined;
    const selection =
        target instanceof HTMLTextAreaElement ||
        target instanceof HTMLInputElement
            ? target.value.slice(
                  target.selectionStart ?? 0,
                  target.selectionEnd ?? 0,
              )
            : "";
    return selection === "" ? { blockId } : { blockId, selection };
};
